module.exports = __webpack_public_path__ + "img/nhai-logo-white.dea6f392.png";